import type { ReceiptTemplate } from '../schema';

export const pizzaHutTemplate: ReceiptTemplate = {
  id: 'pizza-hut',
  name: 'Pizza Hut Receipt',
  brand: 'PIZZA HUT',
  description: 'Pizza restaurant receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'ph-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 140,
        logoHeight: 50,
        businessName: 'PIZZA HUT',
        businessNameFontSize: 20,
        addressLines: [
          '#012847',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ph-order',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'ORDER #2847\nCARRYOUT',
        fontSize: 14,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'ph-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: '01/04/26 19:15  REG 01\nServer: MIKE W.',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'ph-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'ph-item-1', name: 'LG MEAT LOVERS', quantity: '1', price: '17.99'},
          { id: 'ph-item-2', name: 'MED SUPREME', quantity: '1', price: '14.99'},
          { id: 'ph-item-3', name: 'BREADSTICKS 8PC', quantity: '1', price: '6.99'},
          { id: 'ph-item-4', name: 'WINGS 8PC', quantity: '1', price: '9.99'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ph-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'ph-subtotal', label: 'Subtotal', value: '49.96', isBold: false, isLarge: false },
          { id: 'ph-tax', label: 'Tax', value: '4.43', isBold: false, isLarge: false },
          { id: 'ph-total', label: 'TOTAL', value: '54.39', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'ph-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'ph-card', label: 'VISA', value: '************4144' },
          { id: 'ph-auth', label: 'AUTH', value: '284719' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'ph-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '0128472847',
        showValue: false,
        width: 1.5,
        height: 35,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ph-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'ORDER AT PIZZAHUT.COM\nJOIN HUT REWARDS TODAY!',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

